import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { initialState } from './reducer';
import { AlumnoFilter, State } from './types';

const selectState = (state: RootState) => state.photos || initialState;

export const makeSelectPhotos = () =>
  createSelector(selectState, (state: State): any[] => state.photos);

export const makeSelectPhotosCount = () =>
  createSelector(selectState, (state: State): number => state.photosCount);

export const makeSelectAlumnsValidation = () =>
  createSelector(
    selectState,
    (state: State): AlumnoFilter[] => state.alumnsValidation
  );

export const makeSelectAlumnsValidations = () =>
  createSelector(
    makeSelectAlumnsValidation(),
    (AlumnoFilter: AlumnoFilter[]): string =>
      JSON.stringify(
        AlumnoFilter.map((e: AlumnoFilter) => ({
          label: e.ID_USUARIO + ' - ' + e.NOMBRE_USUARIO,
          value: e.ID_USUARIO,
        }))
      )
  );
